/** Product cards for the home page `#products` section */
export const PRODUCTS = [
  {
    id: 'p1',
    title: 'Hybrid Tomato — High-yield line',
    date: 'March 15, 2026',
    dateIso: '2026-03-15',
    image:
      'https://images.unsplash.com/photo-1592841200221-a6892f4c594f?auto=format&fit=crop&w=900&q=80',
    alt: 'Fresh tomatoes on the vine',
    description:
      '<p>Determinate <strong>hybrid</strong> for warm-season tunnels and open field. Strong vine health and steady fruit set through turnover.</p>',
  },
  {
    id: 'p2',
    title: 'Premium Chili & Pepper mix',
    date: 'February 8, 2026',
    dateIso: '2026-02-08',
    image:
      'https://images.unsplash.com/photo-1589829085418-4ec70827f4b5?auto=format&fit=crop&w=900&q=80',
    alt: 'Colorful chili and sweet peppers',
    description:
      '<p>Curated mix of <em>heat levels</em> and colors for retail packs and processing trials. Uniform sizing for line packing.</p>',
  },
  {
    id: 'p3',
    title: 'Leafy Greens — Seasonal blend',
    date: 'January 22, 2026',
    dateIso: '2026-01-22',
    image:
      'https://images.unsplash.com/photo-1540420773420-3366772f4999?auto=format&fit=crop&w=900&q=80',
    alt: 'Fresh lettuce and leafy vegetables',
    description:
      '<p>Seasonal blend for salad lines and baby leaf programs.</p><ul><li>Fast regrowth</li><li>Mild flavor profile</li></ul>',
  },
  {
    id: 'p4',
    title: 'Field Corn — Drought-tolerant hybrid',
    date: 'March 2, 2026',
    dateIso: '2026-03-02',
    image:
      'https://images.unsplash.com/photo-1500937386664-56d1dfef3854?auto=format&fit=crop&w=900&q=80',
    alt: 'Green corn field in sunlight',
    description:
      '<p>Drought-tolerant hybrid with stable standability. Suited to rain-fed and limited-irrigation blocks.</p>',
  },
  {
    id: 'p5',
    title: 'Cucumber — Slicer & pickling pack',
    date: 'February 19, 2026',
    dateIso: '2026-02-19',
    image:
      'https://images.unsplash.com/photo-1449300079323-02e209d9d3a6?auto=format&fit=crop&w=900&q=80',
    alt: 'Cucumbers and slices on a board',
    description:
      '<p>Slicer and pickling types in one program. Crisp texture and <strong>high pack-out</strong> for wholesale.</p>',
  },
  {
    id: 'p6',
    title: 'Brassica — Cabbage & cauliflower line',
    date: 'January 5, 2026',
    dateIso: '2026-01-05',
    image:
      'https://images.unsplash.com/photo-1594282486552-05b4d80fbb9f?auto=format&fit=crop&w=900&q=80',
    alt: 'Cabbage and brassica vegetables',
    description:
      '<p>Cabbage and cauliflower genetics tuned for <em>cool-season</em> slots. Ask about density and days to maturity.</p>',
  },
];
